export const getPercentageInRange = (percentage: number, min: number, max: number) => {
  const range = max + -min;
  const scaledValue = percentage * range;
  return min + scaledValue;
};
